export default __webpack_public_path__ + "static/media/avatar_12.ffaa20dc.svg";